import { makeStyles } from "tss-react/mui";
import { EDeviceType, getThemeBreakpointByDeviceType } from "@utils/getThemeBreakpointByDeviceType";

export const useStyle = makeStyles()((theme) => ({
    sweeprWidget: {
        display: "flex",
        [getThemeBreakpointByDeviceType(theme, EDeviceType.SMALL_MOBILE)]: {
            paddingBottom: theme.spacing(4),
        },
    },
    sweeprWidgetContainer: {
        minHeight: theme.spacing(50),
        width: "100%",
    },
}));
